import { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { Box, Grid } from '@mui/material';
import useStyles from './styles';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../core/constants';
import { AddCircle, Delete } from '@mui/icons-material';
import DropDownSingle from '../../../../Components/DropDownSingle';
import GeneralIconButton from '../../../../Components/GeneralIconButton';

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

/**
 * @name DemandSequenceConfig
 * @description This component is an editor for the demandSequence configuration.
 *
 *   "demandSequence": [
 *   {
 *     "type": "AD_UNIT",
 *     "data": "/424536528/ap_45436_instream_fvp_GI",
 *     "name": "ap_45436_instream_fvp_GI"
 *   }
 * ]
 *
 * @param {{keyData: 'networkData.demandSequence'}} keyData - A key used to identify the configuration in the rawConfig object.
 */
const DemandSequenceConfig = ({ keyData }) => {
	const classes = useStyles();
	const { rawConfig, updateRawConfig } = useContext(FvpConfigContext);

	const addDemandSequenceConfig = () => {
		let clonedSelectedAd = structuredClone(rawConfig);
		const newConfig = { data: 'DUMMY_DATA', type: 'AD_UNIT', name: 'DUMMY_NAME' };
		if (clonedSelectedAd[keyData] && clonedSelectedAd[keyData].length > 0) {
			clonedSelectedAd[keyData] = [...clonedSelectedAd[keyData], newConfig];
		} else {
			clonedSelectedAd[keyData] = [newConfig];
		}

		updateRawConfig(clonedSelectedAd);
	};

	const updateDemandSequenceConfig = (index, property, value) => {
		let clonedRawConfig = structuredClone(rawConfig);
		clonedRawConfig[keyData][index][property] = value;

		updateRawConfig(clonedRawConfig);
	};

	const deleteDemandSequenceConfig = (index) => {
		let clonedRawConfig = structuredClone(rawConfig);
		clonedRawConfig[keyData] = clonedRawConfig[keyData].filter((_, i) => i !== index);

		updateRawConfig(clonedRawConfig);
	};

	return (
		<Box>
			<Typography
				variant="h4"
				fontWeight={600}
				className={classes.heading}
				style={{
					width: 'fit-content',
					textAlign: 'center'
				}}
			>
				DEMAND SEQUENCE
			</Typography>

			{rawConfig &&
				rawConfig[keyData] &&
				rawConfig[keyData].length > 0 &&
				rawConfig[keyData].map((res, index) => {
					return (
						<DemandConfig
							data={res}
							id={index}
							key={index}
							keyData={keyData}
							updateDemandSequenceConfig={updateDemandSequenceConfig}
							deleteDemandSequenceConfig={deleteDemandSequenceConfig}
						/>
					);
				})}

			<Grid item xs={12} style={{ marginTop: '3rem', textAlign: 'center', display: 'flex' }}>
				<AddCircle
					className={classes.adIcon}
					color="primary"
					fontSize="large"
					style={{ margin: '0 auto' }}
					onClick={() => addDemandSequenceConfig()}
				/>
			</Grid>
		</Box>
	);
};

const DemandConfig = ({
	keyData,
	data,
	id,
	updateDemandSequenceConfig,
	deleteDemandSequenceConfig
}) => {
	const classes = useStyles();
	return (
		<Paper sx={{ padding: '4rem', margin: '5rem' }}>
			<Grid container spacing={2} style={{ marginTop: '1.5rem' }}>
				<Grid item xs={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						isObjectEditor={false}
						keyData={keyData + `.${id}.name`}
						label="Name"
						directValue={data.name}
						updateDirectValue={(updatedName) => updateDemandSequenceConfig(id, 'name', updatedName)}
					/>
				</Grid>
				<Grid item xs={7}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						isObjectEditor={false}
						inputStyles={{ width: '90%', marginTop: '1rem' }}
						labelStyles={{ width: '90%' }}
						label="Data"
						keyData={keyData + `.${id}.data`}
						directValue={data.data}
						updateDirectValue={(updatedData) => updateDemandSequenceConfig(id, 'data', updatedData)}
					/>
				</Grid>
				<Grid item xs={2}>
					<DropDownSingle
						system={SYSTEMS.FVP_PLAYER}
						isObjectEditor={false}
						keyData={keyData + `.${id}.type`}
						label="Type"
						list={['AD_UNIT', 'VAST_TAG']}
						formControlStyles={{ width: '70%' }}
						labelStyles={{ width: '100%' }}
						formControlVariant="outlined"
						selectInputStyles={{ margin: '1rem 0' }}
						directValue={data.type}
						updateDirectValue={(updatedType) => updateDemandSequenceConfig(id, 'type', updatedType)}
					/>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<GeneralIconButton
					system={SYSTEMS.FVP_PLAYER}
					name={'FVP_CONFIG_DEMAND_SEQUENCE_DEL_BTN'}
					color="primary"
					className={classes.delIcon}
					onClick={() => deleteDemandSequenceConfig(id)}
				>
					<Delete />
				</GeneralIconButton>
			</Grid>
		</Paper>
	);
};
export default DemandSequenceConfig;
